// Best-effort PII redaction for owned js_error beacons before they leave the
// browser (events_raw, rule 34). Industry standard (Sentry data scrubbers): strip
// emails / phones / tokens / long digit runs from the error message, the stack,
// AND the page URL BEFORE store — a thrown value that embeds a seeker's contact
// (a /readings/<id>/contact URL, a form value echoed in a message) must never
// land in the warehouse. Replace, never hash — we never count by these. Cheap +
// allocation-light: this runs inside an error handler that must never throw.

const EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
// JWT (eyJ... .....) and Bearer tokens before generic digit runs.
const JWT_RE = /\beyJ[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{4,}\b/g;
const BEARER_RE = /\bBearer\s+[A-Za-z0-9._-]{8,}/gi;
// Razorpay entity ids are bearer-capability identifiers on recovery/payment
// URLs. They are not contact PII, but retaining them in events_raw would let an
// analytics reader reopen a seeker's payment route.
const RAZORPAY_ENTITY_RE = /\b(?:order|pay|plink)_[A-Za-z0-9]+\b/g;
// Indian mobile (10 digits starting 6-9, optional +91), the only phone shape we
// collect via the chat-prefill gate (rule 36 / lesson_razorpay_chat_prefill).
const PHONE_RE = /(?:\+?91[-\s]?)?\b[6-9]\d{9}\b/g;
// Card-ish PAN runs (12-19 digits) — redact last, after phone.
const LONG_DIGITS_RE = /\b\d{12,19}\b/g;

/** Redact PII from an arbitrary error string. Safe on undefined/empty. */
export function scrubPii(text: string | undefined): string {
  if (!text) return text ?? "";
  return text
    .replace(EMAIL_RE, "[email]")
    .replace(JWT_RE, "[token]")
    .replace(BEARER_RE, "Bearer [token]")
    .replace(RAZORPAY_ENTITY_RE, "[payment_id]")
    .replace(PHONE_RE, "[phone]")
    .replace(LONG_DIGITS_RE, "[num]");
}
